import { render, staticRenderFns } from "./image-failed.vue?vue&type=template&id=026fb428&scoped=true&"
var script = {}
import style0 from "./image-failed.vue?vue&type=style&index=0&id=026fb428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026fb428",
  null
  
)

export default component.exports